import channels from './Channels'
import CONSTANTS from './utils/config'
class HearingTestEvaluation {
  constructor () {
    this.results = {
      left: [],
      right: []
    }
  }

  recordResult(frequency, amplitude, channel) {
    if (channel === 'single') {
      this.results['left'].push({frequency, amplitude})
      this.results['right'].push({frequency, amplitude})
    } else {
      this.results[channel].push({frequency, amplitude})
    }
  }

  evaluate (frequencies, decibeis) {

    let left = this.getAverageLossByChannel('left', decibeis)
    
    let right = this.getAverageLossByChannel('right', decibeis)

    let evaluation = []

    frequencies.forEach(frequency => {

      let leftAmplitude = this.results.left.find(item => item.frequency === frequency).amplitude
      
      let rightAmplitude = this.results.right.find(item => item.frequency === frequency).amplitude
      
      evaluation.push([frequency, leftAmplitude - decibeis, rightAmplitude - decibeis])
    })

    let results = {}

    Object.keys(this.results).forEach(key => {
      results[key] = this.results[key].map(item => {
        return {
          ...item,
          amplitude: item.amplitude - decibeis
        }
      })
    })

    return {evaluation, left, right, results}
  }

  getAverageLossByChannel (ear, decibeis) {
    let size = this.results[ear].length
    let sum = this.results[ear]
      .map(result => result.amplitude)
      .reduce((a, b) => {
        return a + b
      }, 0)
    return ((sum / size) - decibeis)
  }

  hasResultForStage (channel, frequency) {
    if (channel === 'single') {
      return this.results['left'].some(item => item.frequency === frequency) && this.results['right'].some(item => item.frequency === frequency)
    }
    return this.results[channel].some(item => item.frequency === frequency)
  }
}
export default HearingTestEvaluation